// src/components/SalidaEntradaPatrones/MisMovimientos.jsx
import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  Spinner,
  Alert,
  Button
} from 'react-bootstrap';
import { FaUser, FaBox, FaSyncAlt } from 'react-icons/fa';
import { getMovimientosActivosUsuario } from '../../api/movimientosService';
import { useAuth } from '../../hooks/useAuth';
import { Alertassw } from '../Alertas/Alertassw';
import MovimientoCard from './MovimientoCard';

/**
 * Vista de movimientos activos del usuario actual
 */
const MisMovimientos = ({
  onViewDetails,
  onAgregarOt,
  onCompletarOt,
  onCerrarMovimiento
}) => {
  const { userData } = useAuth();
  const [movimientos, setMovimientos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);

  console.log('MisMovimientos:', movimientos);
  useEffect(() => {
    if (userData?._id) {
      cargarMisMovimientos();
    }
  }, [userData, refreshKey]);

  const cargarMisMovimientos = async () => {
    setLoading(true);
    try {
      const response = await getMovimientosActivosUsuario(userData._id);
      setMovimientos(response.data || []);
    } catch (error) {
      console.error('Error al cargar mis movimientos:', error);
      Alertassw('Error', 'No se pudieron cargar tus movimientos activos', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1);
  };

  const handleAction = (...args) => {
    // Recargar después de cualquier acción
    const callback = args[args.length - 1];
    if (typeof callback === 'function') {
      callback(...args.slice(0, -1));
    }
    setTimeout(() => {
      handleRefresh();
    }, 1000);
  };

  if (loading) {
    return (
      <Container fluid className="py-4 text-center">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3">Cargando tus movimientos...</p>
      </Container>
    );
  }

  return (
    <Container fluid className="py-4">
      {/* Header */}
      <Row className="mb-4">
        <Col>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h2 className="text-primary fw-bold mb-1">
                <FaUser className="me-2" />
                Mis Equipos en Campo
              </h2>
              <p className="text-muted mb-0">
                Equipos patrón actualmente bajo tu responsabilidad
              </p>
            </div>
            <Button
              variant="outline-primary"
              onClick={handleRefresh}
              disabled={loading}
            >
              <FaSyncAlt className={loading ? 'fa-spin' : ''} /> Actualizar
            </Button>
          </div>
        </Col>
      </Row>

      {/* Información del usuario */}
      {userData && (
        <Card className="mb-4 bg-light border-0 w-100">
          <Card.Body className='w-100'>
            <Row className="align-items-center">
              <Col md={6}>
                <h5 className="mb-0">
                  {userData.nombre} {userData.apellido}
                </h5>
                <small className="text-muted">{userData.email}</small>
              </Col>
              <Col md={6} className="text-md-end">
                <div className="d-flex align-items-center justify-content-md-end gap-3">
                  <div>
                    <FaBox className="text-primary me-2" size={24} />
                    <strong className="fs-4">{movimientos.length}</strong>
                    <small className="text-muted d-block">
                      {movimientos.length === 1 ? 'Equipo activo' : 'Equipos activos'}
                    </small>
                  </div>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      )}

      {/* Lista de movimientos (Grid de tarjetas) */}
      {movimientos.length === 0 ? (
        <Alert variant="success" className="text-center py-5">
          <FaBox size={60} className="mb-3 text-muted" />
          <h4>No tienes equipos en campo</h4>
          <p className="mb-0">
            Actualmente no tienes patrones asignados. Cuando se te asignen equipos,
            aparecerán aquí.
          </p>
        </Alert>
      ) : (
        <>
          <Row className="g-3 mb-4">
            {movimientos.map((movimiento) => (
              <Col key={movimiento._id} md={6} lg={4}>
                <MovimientoCard
                  movimiento={movimiento}
                  showActions={true}
                  onViewDetails={onViewDetails}
                  onAgregarOt={onAgregarOt}
                  onCompletarOt={onCompletarOt}
                  onCerrarMovimiento={onCerrarMovimiento}
                />
              </Col>
            ))}
          </Row>

          {/* Información adicional */}
          <Card className="bg-light border-0 w-100">
            <Card.Body className='w-100'>
              <h6 className="fw-bold mb-2">Recordatorios:</h6>
              <ul className="mb-0">
                <li>Puedes agregar más OTs a los movimientos si es necesario</li>
                <li>
                  Cuando termines con un equipo, devuélvelo cerrando el movimiento
                </li>
              </ul>
            </Card.Body>
          </Card>
        </>
      )}
    </Container>
  );
};

export default MisMovimientos;
